import { getStatusColor, formatStatus } from '../../utils/liveSession/sessionUtils';

/**
 * Top banner component for live session
 */
export const LiveSessionBanner = ({ session, isConsultant, otherPerson }) => {
  // Guard against null session
  if (!session) {
    return (
      <div className="bg-gradient-to-r from-emerald-500 to-blue-500 dark:from-emerald-600 dark:to-blue-600 text-white py-4 px-6 shadow-lg">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-white/20 dark:bg-white/30 p-2 rounded-full">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <h1 className="text-xl font-bold">Live Assessment Session</h1>
              <p className="text-sm text-white/80 dark:text-white/90">Loading...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-emerald-500 to-blue-500 dark:from-emerald-600 dark:to-blue-600 text-white py-4 px-6 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="bg-white/20 dark:bg-white/30 p-2 rounded-full">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          </div>
          <div>
            <h1 className="text-xl font-bold">Live Assessment Session</h1>
            <p className="text-sm text-white/80 dark:text-white/90">
              {isConsultant 
                ? `Assessing ${otherPerson?.name || 'User'}`
                : `With Consultant ${otherPerson?.name || 'Loading...'}`
              }
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          {/* Real-time indicator */}
          <div className="flex items-center space-x-2 bg-white/20 dark:bg-white/30 px-3 py-1 rounded-full">
            <div className="w-2 h-2 bg-green-400 dark:bg-green-300 rounded-full animate-pulse"></div>
            <span className="text-sm font-medium">Live</span>
          </div>
          
          {/* Status badge */}
          <span className={`px-3 py-1 rounded-full text-sm font-semibold border ${getStatusColor(session?.status || 'pending')}`}>
            {formatStatus(session?.status || 'pending')}
          </span>
        </div>
      </div>
    </div>
  );
};

